import { GetterTree } from 'vuex'

import { COLOR_PATTERN_TYPES, OBJECT_PUBLISH_STATUS } from '@/common/constants'
import { getSizeInputQuery } from '@/common/utils/common'
import { ProductState } from '@/product/types'

// Using double equals on purpose due to difference between data type of id field from json data and graphQl api

const getters: GetterTree<ProductState, ProductState> = {
  imageLoading: ({ imageLoading }) => imageLoading,
  validQuantity: ({ validQuantity }) => validQuantity,
  isSendable: ({ validQuantity, serverError, estimate, productLoading }: ProductState) =>
    validQuantity && !serverError && estimate.quantity > 0 && !productLoading,
  isSimplifiedSendable: ({ serverError, productLoading }: ProductState) =>
    !serverError && !productLoading,
  skuImages: ({ productDetail }) => productDetail.sku.skuImages || [],
  selectedColorPatternOption: ({ productDetail, estimate }) => {
    const { sku } = productDetail
    if (
      !estimate.selectedColorPattern?.id &&
      sku.skuColorPatterns?.length === 0
    )
      return null
    return sku.skuColorPatterns?.find(
      option => option.colorPattern.displayName == estimate.selectedColorPattern.colorPattern.displayName
    )
  },
  selectedEditPattern: ({ productDetail, estimate }) => {
    const { sku } = productDetail
    if (!estimate.selectedEditPattern?.id && sku.skuEditPatterns?.length === 0)
      return null
    return sku.skuEditPatterns?.find(
      option => option.id == estimate.selectedEditPattern.id
    )
  },
  skuSizes: ({ productDetail }) => {
    return productDetail.sku.availableSizes || []
  },
  sizeInputQuery: ({ sizeInput }) => {
    return getSizeInputQuery(sizeInput)
  },
  isOrderPlainProduct: ({ productDetail, estimate }) => {
    const { sku } = productDetail
    const selectedColorPatternId = estimate.selectedColorPattern?.id
    const pattern = sku.skuColorPatterns?.find(
      item => item.id == selectedColorPatternId
    )
    return !!(
      pattern && pattern.colorPattern.type === COLOR_PATTERN_TYPES.PLAIN
    )
  },
  addonProductPsi: ({ estimate }) => {
    return estimate.addonPrintableSkuId || undefined
  },
  invalidSizeSelection: ({ estimate }) => {
    return estimate.quantity <= 0
  },
  invalidProductSetSelection: ({ productDetail, addonProduct }) => {
    return productDetail.product.hasAddonProducts && !addonProduct?.selectedAddonProductId
  },
  invalidPrintingSelection: ({ estimate, isPrintingSelected }) => {
    const isPlain = estimate.selectedColorPattern?.colorPattern?.type === COLOR_PATTERN_TYPES.PLAIN
    return isPrintingSelected && isPlain
  },
  isProductUnpublished: ({ productDetail }) => {
    return productDetail.product.publishStatus === OBJECT_PUBLISH_STATUS.UNPUBLISHED
  },
  isFastShippingSelected: ({ productDetail }) => {
    return !!productDetail?.product?.normalProductId && !productDetail?.product?.fastShippingProductId
  },
  psi: ({ estimate }) => {
    return estimate.printableSkuId
  },
  isColorPatternPlainSelected: ({ estimate }) => {
    return estimate.selectedColorPattern?.colorPattern?.type === COLOR_PATTERN_TYPES.PLAIN
  },
  isNotPrintableProduct: ({ estimate, productDetail }) => {
    return productDetail.sku?.skuColorPatterns?.length <=1
      && estimate.selectedColorPattern?.colorPattern?.type === COLOR_PATTERN_TYPES.PLAIN
  },
  outOfStockSizes: ({ productDetail }) => {
    return productDetail.sku.availableSizes?.filter(item => !item.hasStock)
  }
}

export default getters
